export var LocalActions;
(function (LocalActions) {
  let Set = /*#__PURE__*/(() => {
    class Set {
      static {
        this.type = '[Local] Set';
      }
      constructor(name, data) {
        this.name = name;
        this.data = data;
      }
    }
    return Set;
  })();
  LocalActions.Set = Set;
})(LocalActions || (LocalActions = {}));
// export UserActions;